import langAdminDocumentAccess from './langs/langAdminDocumentAccess';
import langAdminDocumentDownloadLogs from './langs/langAdminDocumentDownloadLogs';
import langAdminDocumentEmailNotifications from './langs/langAdminDocumentEmailNotifications';
import langAdminEmailNotifications from './langs/langAdminEmailNotifications';
import langAdminInvestors from './langs/langAdminInvestors';
import langAdminNavigation from './langs/langAdminNavigation';
import langAdminNotificationMonitoring from './langs/langAdminNotificationMonitoring';
import langAdminUserEmailNotifications from './langs/langAdminUserEmailNotifications';

const AdminLangs = [
	langAdminDocumentAccess,
	langAdminDocumentDownloadLogs,
	langAdminEmailNotifications,
	langAdminDocumentEmailNotifications,
	langAdminUserEmailNotifications,
	langAdminNotificationMonitoring,
	langAdminNavigation,
	langAdminInvestors,
];

export default AdminLangs;
